const triggerUpdateCookieConsent=()=>{if(typeof window!=='undefined'&&window.Cookiebot){window.Cookiebot.renew();}};export default triggerUpdateCookieConsent;